import React, { useEffect, useState } from "react";
import { getWorkOrderSummary } from "../../api/work-orderAPI";


const WorkOrderCounts = () => {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    const loadSummary = async () => {
      const data = await getWorkOrderSummary();
      setSummary(data);
    };
    loadSummary();
  }, []);

  if (!summary) return <div>Loading...</div>;

  return (
    <div className='col-xxl-4'>
      <div className='card'>
        <div className='card-body p-20'>
          <div className='row g-3'>
            <div className='col-md-12'>
              <h6 className="mb-2 fw-bold text-lg">Work Order Summary</h6>
                <div className='row g-3'>
                  <div className='col-sm-6 col-xs-6'>
                    <div className='radius-12 overflow-hidden p-20'>
                      <div className='text-center mb-3'>
                        <span className="bg-info-focus text-info-main px-16 py-2 rounded-pill fw-medium text-sm">
                          Open
                        </span>
                      </div>
                      <div className='text-center'>
                        <h5 className='mb-0'>{summary.open}</h5>
                      </div>
                    </div>
                  </div>
                  <div className='col-sm-6 col-xs-6'>
                    <div className='radius-12 overflow-hidden p-20'>
                      <div className='text-center mb-3'>
                        <span className="bg-primary-focus text-primary-main px-16 py-2 rounded-pill fw-medium text-sm">
                          In Progress
                        </span>
                      </div>
                      <div className='text-center'>
                        <h5 className='mb-0'>{summary.inProgress}</h5>
                      </div>
                    </div>
                  </div>
                  <div className='col-sm-6 col-xs-6'>
                    <div className='radius-12 overflow-hidden p-16'>
                      <div className='text-center mb-3'>
                        <span className="bg-warning-focus text-warning-main px-12 py-2 rounded-pill fw-medium text-sm">
                          On Hold
                        </span>
                      </div>
                      <div className='text-center'>
                        <h5 className='mb-0'>{summary.onHold}</h5>
                      </div>
                    </div>
                  </div>
                  <div className='col-sm-6 col-xs-6'>
                    <div className='radius-12 overflow-hidden p-16'>
                      <div className='text-center mb-3'>
                        <span className="bg-success-focus text-success-main px-12 py-2 rounded-pill fw-medium text-sm">
                          Complete 1 Month
                        </span>
                      </div>
                      <div className='text-center'>
                        <h5 className='mb-0'>{summary.completedLast30Days}</h5>
                      </div>
                    </div>
                  </div>
                  <div className='col-sm-6 col-xs-6'>
                    <div className='radius-12 overflow-hidden p-16'>
                      <div className='text-center mb-3'>
                        <span className="bg-danger-focus text-danger-main px-12 py-2 rounded-pill fw-medium text-sm">
                          Overdue
                        </span>
                      </div>
                      <div className='text-center'>
                        <h5 className='mb-0'>{summary.overdue}</h5>
                      </div>
                    </div>
                  </div>
                  <div className='col-sm-6 col-xs-6'>
                    <div className='radius-12 overflow-hidden p-16'>
                      <div className='text-center mb-3'>
                        <span className="bg-secondary-focus text-secondary-main px-12 py-2 rounded-pill fw-medium text-sm">
                          Complete %
                        </span>
                      </div>
                      <div className='text-center'>
                        <h5 className='mb-0'>{summary.completionPercent}%</h5>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkOrderCounts;
